import mapFunction from './mapResources';

export default mapFunction('building_issues', {
    isFetching: false,
    items: []
});